module.exports = __webpack_public_path__ + "static/media/blog8.f038c7dc.jpg";